import type { FaireProductEntity } from "../../entity_types/product";

export const p_cq5yaj8njs: FaireProductEntity = {
  token: "p_cq5yaj8njs",
  type: "product",
  name: "Dwell Dripper - Pour Over",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/881fa28371b246e1c5d21160a80e7f3f3e69c2602686b3d495413463536b3e31.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0400588cd68153f09d21e612945af84dd4cc83bdfc1e3c1f797d6fef9f81be4.webp",
    "https://cdn.faire.com/fastly/a7eeca801ceb9eac71fd20e9f05d8ad3be63e8e21a4a8ddefcd4226ce2cf1b19.webp",
    "https://cdn.faire.com/fastly/8a038bf3e0476ce5e58fe85ab6e00c627a20c120711a5a0da6ec803a23aca333.webp",
    "https://cdn.faire.com/fastly/f298b8e941600cb2da4e6fa6c4f6faa6fc52b1e0be2e24ac6d7767b43d4d318f.webp",
    "https://cdn.faire.com/fastly/cfc7d26425b82c1361a76092a57ba8829c27186ba09f403cb4420b569a3f2d97.webp",
    "https://cdn.faire.com/fastly/60510aba8f0723b278d31262787ce572ada729a0fe3104721b4ffa915dd5e5f8.webp",
    "https://cdn.faire.com/fastly/61a6cf25345c66c7b16eba885c41fa2376cf4b39f0f9c3c095768f7da4737e8b.webp",
    "https://cdn.faire.com/fastly/6b3a1fb1464b6bd778a26a8274031c21d1e71e85c90389c1a138cb58e0d32309.webp",
    "https://cdn.faire.com/fastly/0d1462ca13fd78e00b1d5ecc82bad72adacaa10ec08ae9dbfb80bbc13e13cfd3.webp"
  ],
  priceDollars: 17.99,
  description: "Made from BPA-free silicone, this unique bottomless brewer delivers cafe-quality coffee from the comfort of your home. The non-restrictive design generates a free-flowing method, creating an aromatic and beautiful brew in less than 3 minutes.",
  tags: [],
  msrpDollars: 35.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:49.472Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
